// api/services/adtechs.ts
import { handleRequest } from '@/api';
import type { AdTech } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

interface AdTechPayload {
    adtech_name: string;
    country_code: string;
    country_list?: string[];
    currency_code?: string;
    is_active?: boolean;
    requires_job_number?: boolean;
    requires_charged_cpm?: boolean;
}

interface AdTechUpdatePayload extends AdTechPayload {
    id: number;
}

export const getAdtechs = (opts: FetchOpts = {}): Promise<AdTech[]> =>
    handleRequest<AdTech[]>('get', '/adtechs/', opts);

export const createAdtech = (adtechData: AdTechPayload): Promise<AdTech> =>
    handleRequest<AdTech>('post', '/adtechs/', adtechData, 'AdTech created successfully!');

export const updateAdtech = (payload: AdTechUpdatePayload): Promise<AdTech> =>
    handleRequest<AdTech>('put', `/adtechs/${payload.id}`, payload, 'AdTech updated successfully');
